module.exports = __webpack_public_path__ + "static/media/3_licious.cf7b0762.svg";